import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { paginationData } from "../../utilities/functions";
import { fetchApi } from "../fetchApi";

const getDomain = (search) => {
  const domain = [];
  const { query, type, specific } = search;
  if (query) {
    domain.push(["name", "ilike", query]);
  }
  if (specific) {
    domain.push(["vtexAdminCateg", "ilike", "true"]);
  }
  if (type) {
    domain.push(JSON.parse(type));
  }
  return domain;
};

export async function categoriesSearchRead({
  context,
  company_id,
  pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },

  search = { query: "", type: "" },
  sort = { type: "", dir: "asc" },
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      model: "product.public.category",
      domain: getDomain(search),
      fields: ["id", "display_name", "parent_id", "tax_id", "vtex_commission"],
      ...paginationData(pagination),
      sort: sort?.type ? `${sort?.type} ${sort?.dir}` : "", //   direction in the sorting parameter
      context: {
        lang: context.lang,
        tz: context.tz,
        uid: context.uid,
        allowed_company_ids: [company_id],
        params: {
          cids: company_id,
          model: "product.public.category",
          view_type: "list",
        },
        bin_size: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: "/web/dataset/search_read" });
}
